import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './VpVideoPlayer.module.less';

export const VpVideoPlayer = ({
  mediaUrl,
  onLoad,
  thumbnailUrl,
  onEnd = () => {},
  noDownload = false,
  autoPlay = false,
  muted = false
}) => {
  const videoPlayerRef = useRef(null);

  const handleOnLoad = () => {
    onLoad && onLoad();
  };

  return (
    <section className={styles.vpVideoContainer}>
      <video
        ref={videoPlayerRef}
        onLoadedData={handleOnLoad}
        autoPlay={autoPlay}
        controls
        onEnded={onEnd}
        muted={muted}
        {...(noDownload ? { controlsList: 'nodownload' } : {})}
        {...(thumbnailUrl ? { poster: thumbnailUrl } : {})}
      >
        <source src={mediaUrl} key={mediaUrl} />
      </video>
    </section>
  );
};

VpVideoPlayer.propTypes = {
  mediaUrl: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  onLoad: PropTypes.func,
  onEnd: PropTypes.func,
  noDownload: PropTypes.bool,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool
};

export default VpVideoPlayer;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpVideoPlayer/VpVideoPlayer.jsx